import React from 'react';
import PropTypes from 'prop-types';
import { includes, split, head } from 'lodash';
import { RootContainer, Main, FlexContainer } from 'base-components';

const MainContainer = ({ children }) => {
    const isPdfPath = includes(['dispatch-pdf', 'order-pdf', 'order-list', 'order-labels', 'positions-qr'], split(location.pathname, '/')[1]);
    if (isPdfPath) return <div style={{ width: '100%' }}>{ children }</div>;
    return (
        <Main style={styles.container} overflowY='hidden' withFooter={false}>
            <FlexContainer style={{ alignItems: 'center', width: '100%', height: '100%' }}>
                { children }
            </FlexContainer>
        </Main>
    );
};

const Landing = ({ children }) => (
    <RootContainer>
        <MainContainer>
            { children }
        </MainContainer>
    </RootContainer>
);

Landing.propTypes = {
    children: PropTypes.any
};

const styles = {
    container: {
        width: '100%',
        height: '100vh',
        margin: '0 auto',
        justifyContent: 'center',
        display: 'flex',
        alignItems: 'center'
    }
};

export default Landing;
